/* ============================================================================
   BOHO — boho-movimento.js  (THK, 20/07)

   Non nasconde niente: nascondere e' compito di boho-movimento.css, e solo
   sotto `html.js`. Questo file fa una cosa sola: decidere QUANDO e in che
   ORDINE aggiungere la classe `is-riv`.

   La COMPARSA AL CARICAMENTO (hero, header, prima schermata della scheda
   prodotto) NON passa da qui: e' fatta con animazioni CSS in
   boho-movimento.css, perche' questo file e' `defer` e girerebbe troppo tardi.
   Qui si governa la RIVELAZIONE ALLO SCORRIMENTO.

   Regole di casa rispettate:
   - una sola curva, cubic-bezier(.16,1,.3,1), gia' nel CSS;
   - stagger di 70 ms fra fratelli che entrano insieme, al massimo 7 passi;
   - unobserve dopo la prima rivelazione: niente ri-animazione tornando su;
   - tre reti di sicurezza (vedi sotto) piu' quella, indipendente, in <head>;
   - will-change acceso solo per la durata della transizione e poi tolto;
   - nessun conflitto con boho-magia.js: classi, dataset e observer sono altri
     (qui: is-riv / data-bh-ord / data-bh-base / data-bh-on).

   Le due liste qui sotto sono IDENTICHE a quelle di boho-movimento.css.
   Se cambi una, cambia l'altra.
   ==========================================================================*/
(function () {
  'use strict';

  /* Segnale per lo script di <head>: il sistema di movimento e' arrivato,
     non serve la rete d'emergenza `bh-nomo`. */
  window.bhMovimento = true;

  var SEL_SU = [
    '#MainContent .bh-eyebrow',
    '#MainContent .bh-hero h1.bh-display',
    '#MainContent .bh-lead',
    '#MainContent .bh-btns > a',
    '#MainContent .bh-num',
    '#MainContent h2.bh-h3',
    '#MainContent .bh-cat > li',
    '#MainContent .bh-info',
    '#MainContent .bh-neg-foto',
    '#MainContent .bh-neg-cap',
    '#MainContent .bh-form > *',
    '#MainContent .bh-note',
    '#MainContent .section-resource-list__header .group-block-content > *',
    '#MainContent .resource-list__item',
    '#MainContent .product-grid__item',
    '#MainContent .section-content-wrapper > *',
    '#MainContent .page-content rte-formatter > *',
    '#MainContent .page-content rte-formatter > div > *',
    '#MainContent .product-details .group-block-content > *',
    '.bh-footer__wrap > *',
    '.bh-footer__legale'
  ].join(',');

  var SEL_VELO = [
    '#header-group > *',
    '#MainContent marquee-component',
    '#MainContent .product-information__media',
    '#MainContent .facets-block-wrapper',
    '.utilities > *'
  ].join(',');

  var TUTTI = SEL_SU + ',' + SEL_VELO;

  /* Ordine esplicito della hero, tenuto anche se la comparsa e' in CSS:
     se un giorno le animazioni CSS venissero tolte, la sequenza resta. */
  var SEQUENZA_HERO = [
    '#MainContent .bh-hero .bh-eyebrow',
    '#MainContent .bh-hero h1.bh-display',
    '#MainContent .bh-hero .bh-lead',
    '#MainContent .bh-hero .bh-btns > a'
  ].join(',');

  /* Scheda prodotto: la colonna informazioni parte un passo dopo la galleria. */
  var SFASA_PRODOTTO = '#MainContent .product-details .group-block-content > *';

  var PASSO = 70; /* ms fra un fratello e l'altro */
  var MAX_PASSI = 7; /* oltre, il ritardo non cresce piu' */
  var CODA = 1200; /* ms: quando la transizione e' certamente finita */
  var RETE = 2500; /* ms: rete di sicurezza interna */

  var doc = document;
  var html = doc.documentElement;
  var osservatore = null;
  var noti = []; /* tutti i nodi presi in carico */

  function ridotto() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  /* Toglie di mezzo l'intero sistema: il CSS non nasconde piu' niente. */
  function resaTotale() {
    html.classList.add('bh-nomo');
  }

  function mostra(el, indice) {
    if (!el || el.classList.contains('is-riv')) return;

    var ord = el.getAttribute('data-bh-ord');
    var base = parseInt(el.getAttribute('data-bh-base') || '0', 10) || 0;
    var passi =
      ord !== null && ord !== ''
        ? parseInt(ord, 10) || 0
        : Math.min(indice, MAX_PASSI) + base;
    var ritardo = passi * PASSO;

    el.style.transitionDelay = ritardo + 'ms';
    el.style.willChange = 'opacity, transform';
    el.classList.add('is-riv');

    /* will-change tolto appena non serve piu': non deve restare acceso,
       divorerebbe memoria su griglie lunghe. */
    window.setTimeout(function () {
      el.style.willChange = '';
      el.style.transitionDelay = '';
    }, ritardo + CODA);
  }

  function inOrdineDiDocumento(a, b) {
    if (a === b) return 0;
    var p = a.compareDocumentPosition(b);
    return p & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
  }

  function alPassaggio(voci, obs) {
    var attivi = [];
    for (var i = 0; i < voci.length; i++) {
      if (voci[i].isIntersecting) attivi.push(voci[i].target);
    }
    if (!attivi.length) return;

    attivi.sort(inOrdineDiDocumento);

    /* Lo sfalsamento vale fra elementi che entrano INSIEME e hanno lo stesso
       genitore (schede di una griglia, tessere, colonne del footer, blocchi
       di una pagina CMS). Un elemento che entra da solo non aspetta nessuno. */
    var conta = [];
    var chiavi = [];
    for (var j = 0; j < attivi.length; j++) {
      var el = attivi[j];
      var p = el.parentNode;
      var k = chiavi.indexOf(p);
      if (k === -1) {
        k = chiavi.push(p) - 1;
        conta[k] = 0;
      }
      mostra(el, conta[k]);
      conta[k] += 1;
      obs.unobserve(el);
    }
  }

  function prendiInCarico(nodi) {
    for (var i = 0; i < nodi.length; i++) {
      var el = nodi[i];
      if (el.getAttribute('data-bh-on') === '1') continue;
      el.setAttribute('data-bh-on', '1');
      noti.push(el);
      osservatore.observe(el);
    }
  }

  /* Mostra d'ufficio tutto cio' che e' GIA' davanti agli occhi e non e'
     ancora comparso. Quello che sta piu' in basso NON si tocca: e' li' che
     serve la rivelazione a scorrimento, e mostrarlo adesso la cancellerebbe. */
  function spazzaViewport(nodi) {
    if (html.classList.contains('bh-nomo')) return;
    var alto = window.innerHeight || 800;
    for (var i = 0; i < nodi.length; i++) {
      var el = nodi[i];
      if (el.classList.contains('is-riv')) continue;
      var r;
      try {
        r = el.getBoundingClientRect();
      } catch (e) {
        r = null;
      }
      if (r && r.top > alto) continue; /* sta sotto la piega: tocca all'osservatore */
      el.style.transitionDelay = '0ms';
      el.classList.add('is-riv');
      if (osservatore) osservatore.unobserve(el);
    }
  }

  function reteDiSicurezza(nodi) {
    window.setTimeout(function () {
      if (html.classList.contains('bh-nomo')) return;
      /* Se non e' comparso NIENTE di niente, l'osservatore e' rotto o non e'
         mai partito: si spegne l'intero sistema e la pagina torna com'era. */
      if (!doc.querySelector('.is-riv')) {
        resaTotale();
        return;
      }
      spazzaViewport(nodi);
    }, RETE);
  }

  /* Terzo livello: mentre si scorre, qualunque cosa arrivi davanti agli occhi
     e sia ancora nascosta viene mostrata comunque. Costa una passata ogni
     300 ms e si spegne da sola quando non resta piu' niente da rivelare. */
  function guardiaDiScorrimento() {
    var quando = 0;
    var atteso = false;
    function passata() {
      atteso = false;
      quando = Date.now();
      var restano = false;
      for (var i = 0; i < noti.length; i++) {
        if (!noti[i].classList.contains('is-riv')) {
          restano = true;
          break;
        }
      }
      if (!restano) {
        window.removeEventListener('scroll', innesca, true);
        window.removeEventListener('resize', innesca);
        return;
      }
      spazzaViewport(noti);
    }
    function innesca() {
      if (atteso) return;
      atteso = true;
      window.setTimeout(passata, Math.max(0, 300 - (Date.now() - quando)));
    }
    window.addEventListener('scroll', innesca, true);
    window.addEventListener('resize', innesca);
  }

  function avvia() {
    var nodi;
    try {
      nodi = [].slice.call(doc.querySelectorAll(TUTTI));
    } catch (e) {
      resaTotale();
      return;
    }

    if (!nodi.length) return;

    /* Niente IntersectionObserver o "Riduci movimento": tutto visibile subito,
       senza mezze misure. */
    if (!('IntersectionObserver' in window) || ridotto()) {
      resaTotale();
      return;
    }

    /* Ordini espliciti (hero e scheda prodotto) prima di osservare. */
    try {
      var seq = doc.querySelectorAll(SEQUENZA_HERO);
      for (var i = 0; i < seq.length; i++) {
        seq[i].setAttribute('data-bh-ord', String(i));
      }
      var det = doc.querySelectorAll(SFASA_PRODOTTO);
      for (var j = 0; j < det.length; j++) {
        det[j].setAttribute('data-bh-base', '1');
      }
    } catch (e2) {
      /* niente: l'ordine esplicito e' un lusso, la rivelazione no */
    }

    osservatore = new IntersectionObserver(alPassaggio, {
      /* root implicito = viewport. Vale anche quando a desktop lo scroller
         e' .page-wrapper: l'intersezione tiene conto del ritaglio degli
         antenati. Il margine negativo in basso fa partire l'effetto appena
         il bordo alto dell'elemento si affaccia, non a meta' schermo. */
      root: null,
      rootMargin: '0px 0px -4% 0px',
      threshold: 0.06
    });

    prendiInCarico(nodi);
    reteDiSicurezza(noti.slice());
    guardiaDiScorrimento();

    /* Sezioni ri-renderizzate da Shopify (filtri di collezione, "carica altri",
       cambio variante): i nodi nuovi nascono nascosti dal CSS. Vanno presi in
       carico, altrimenti resterebbero invisibili. */
    if ('MutationObserver' in window) {
      var attesa = null;
      new MutationObserver(function () {
        if (attesa) window.clearTimeout(attesa);
        attesa = window.setTimeout(function () {
          var nuovi;
          try {
            nuovi = [].slice.call(doc.querySelectorAll(TUTTI)).filter(function (el) {
              return el.getAttribute('data-bh-on') !== '1';
            });
          } catch (e3) {
            return;
          }
          if (!nuovi.length) return;
          prendiInCarico(nuovi);
          reteDiSicurezza(nuovi);
        }, 120);
      }).observe(doc.body, { childList: true, subtree: true });
    }
  }

  try {
    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', avvia, { once: true });
    } else {
      avvia();
    }
  } catch (e) {
    resaTotale();
  }
})();
